import React from "react";

const CalciteScrollableTooltip = (props) => {
  const tooltipRef = React.useRef(null);

  React.useEffect(() => {
    var style = document.createElement("style");
    style.innerHTML = `
      div.container {
          overflow: auto;
      }
    `;
    tooltipRef.current.shadowRoot?.appendChild(style);
  }, []);

  return (
    <calcite-tooltip ref={tooltipRef} {...props}>
      {props.children}
    </calcite-tooltip>
  );
};

export default CalciteScrollableTooltip;
